import { useState, ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';
import './Accordion.css';
import { ReactComponent as ArrowDown } from '../../assets/icons/arrow-down.svg';
import clsx from 'clsx';

interface AccordionItemProps {
    title: React.ReactNode;
    children: ReactNode;
}

export const Accordion = ({ title, children }: AccordionItemProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleAccordion = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        e.preventDefault();
        setIsOpen(!isOpen);
    };

    return (
        <div className="border rounded-lg">
            <div className='flex justify-between items-center px-2 py-1'>
                <span>{title}</span>
                <button
                    className="p-2"
                    onClick={toggleAccordion}
                >
                    <span className='text-[8px] leading-4'>
                        <ArrowDown className={clsx(isOpen && 'rotate-180')} />
                    </span>
                </button>
            </div>
            <CSSTransition
                in={isOpen}
                timeout={300}
                classNames="accordion"
                unmountOnExit
            >
                <div className="bg-white rounded-b-lg">
                    {children}
                </div>
            </CSSTransition>
        </div>
    );
};
